import { render, staticRenderFns } from "./VerificationDialog.vue?vue&type=template&id=eda57960&"
import script from "./VerificationDialog.vue?vue&type=script&lang=js&"
export * from "./VerificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports